import { Component, input, OnInit, signal, Type } from '@angular/core';
import { PricingEditFormComponent } from '../../../inventory/actions/form/edit/pricing-edit-form/pricing-edit-form.component';
import { Work } from '../../../models/work.model';

const mapComponent = {
  'InventoryAction::Pricing': PricingEditFormComponent,
}

@Component({
  selector: 'wpl-edit-document',
  standalone: false,
  templateUrl: './edit-document.component.html',
  styleUrl: './edit-document.component.scss'
})
export class EditDocumentComponent implements OnInit {

  workInstance = input.required<Work>();

  component = signal<Type<any> | undefined>(undefined);

  get document() {
    return this.workInstance().document;
  }

  ngOnInit(): void {
    this.component.set(mapComponent[this.workInstance().document.type]);
  }
}
